export const enData = `
  <div class="paragraph">
    <div class="title">What should I do before sending my phone?</div>
    <div class="text-box">
      <div class="text">
      Before shipping your device, please make sure to:
      </div>
      <div class="text">
      - Erase all personal data and remove any screen lock PINs, passwords, or patterns
      </div>
      <div class="text">
      - Perform a full factory reset
      </div>
      <div class="text">
      - For iPhones: Disconnect your iCloud account by turning off Find My iPhone
      </div>
      <div class="text">
      - For Android phones: Remove your Google account (Settings > Accounts > Google > Remove Account)
      </div>
      <div class="text">
      These steps ensure the device is no longer linked to your personal account and help prevent activation lock issues during the evaluation. They also protect your personal information and allow our inspection team to process the device smoothly.
      </div>
    </div>
  </div>

  <div class="paragraph">
    <div class="title">Can I send a phone with a SIM lock?</div>
    <div class="text-box">
      <div class="text">
      No, we do not accept phones locked to a specific carrier (SIM-locked devices).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Do I need to send accessories (charger, cable)?</div>
    <div class="text-box">
      <div class="text">
      Not mandatory, but recommended. Including accessories helps improve sustainability by supporting reuse and proper recycling.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Should I send my headphones?</div>
    <div class="text-box">
      <div class="text">No. For hygiene reasons, headphones will not be included in the valuation and will be discarded.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Do I need to send my purchase invoice?</div>
    <div class="text-box">
      <div class="text">
      No. The invoice is not required for the evaluation or payment process. You may keep it for your own records.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">How do you evaluate my phone?</div>
    <div class="text-box">
      <div class="text">
      Once your phone arrives at our inspection facility, we use diagnostic software and manual checks to evaluate its condition.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What if the condition I reported is different from your evaluation?</div>
    <div class="text-box">
      <div class="text">
      If there's a discrepancy, we will email you a revised offer. If the final quote is equal to or less than €13 lower than your initial evaluation, we will proceed automatically. If the difference is higher, you'll have 5 business days to accept or reject the new offer.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What happens if I reject the revised offer?</div>
    <div class="text-box">
      <div class="text">
      Your device will be returned to you free of charge (for reverse shipping). The return process will start within 5 business days after your rejection confirmation.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What if I don't respond to the revised offer?</div>
    <div class="text-box">
      <div class="text">
      If we do not receive a response within 5 business days, the revised offer will be automatically accepted and processed.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What happens to my data?</div>
    <div class="text-box">
      <div class="text">
      Please erase all personal data before shipping your device. If we detect any remaining data, we will pause processing and contact you for permission before deletion. We comply with the General Data Protection Regulation (GDPR - Regulation EU 2016/679).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Who covers the shipping cost?</div>
    <div class="text-box">
      <div class="text">
      The initial (reverse) shipment to our facility is free of charge. If you reject our revised offer, we will also cover the return shipping.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">What if my package is lost during shipping?</div>
    <div class="text-box">
      <div class="text">
      Danghuan does not assume liability for lost shipments, even when the shipping label provided by us is used.
      </div>
      <div class="text">
      However, if your package appears to be lost, we are happy to assist you with the claim process to the courier. To do so:
      </div>
      <div class="text">
      - Please ensure you used the official shipping label and kept the shipping receipt
      </div>
      <div class="text">
      - You may contact our Customer Support team at support@danghuan.eu
      </div>
      <div class="text">
      - Lost parcel claims can be initiated starting 15 calendar days after the shipping date
      </div>
      <div class="text">
      Note: Any potential compensation is subject to the courier’s policy, not Danghuan’s.
      </div>
      
    </div>
  </div>
  <div class="paragraph">
    <div class="title">When will I get paid?</div>
    <div class="text-box">
      <div class="text">
      Once you accept the final offer, payment will be processed via bank transfer within 3 business days. Please ensure your IBAN or payment information is correct.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Can I cancel my trade-in?</div>
    <div class="text-box">
      <div class="text">
      Yes, but only if your device has not yet been paid out. To cancel, please contact us at support@danghuan.eu as soon as possible.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">How do I cancel a confirmed trade-in order?</div>
    <div class="text-box">
      <div class="text">
      If you have already received the confirmation email but wish to cancel, email us at support@danghuan.eu with your order number. We will assist you accordingly.
      </div>
    </div>
  </div>
`;
